export default __webpack_public_path__ + "static/media/no-delete-campaign.0c05ddac.svg";